import AddressIcon from '@material-ui/icons/TurnedIn';
import AddressList from './AddressList';
import AddressCreate from './AddressCreate';
import AddressEdit from './AddressEdit';
const AddressModule = {
    list: AddressList,
    icon: AddressIcon,
    create: AddressCreate,
    edit: AddressEdit,
}; export default AddressModule;